module.exports = __webpack_public_path__ + "img/sensor_0_0.b0cfdb62.png";